import { SliderTrack } from './SliderTrack';

// TODO: in v9, move styled() from SliderTrack.jsx to here
export var StyledSliderTrack = SliderTrack;